import {useContext} from "react";

import {AppContext} from "../../providers/AppProvider";

export function useAppContext() {
    return useContext(AppContext);
}
